import { useEffect, useRef, useState } from 'react';
import { cn } from '@utils/cn';
import { EdgeProps } from './types';
import { EdgeElement } from './element';
import { getFillTeeth } from './helpers';

export const Edge = ({ className, count, fill, size, ...rest }: EdgeProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!fill || !element) return;
    const observer = new ResizeObserver(([entry]) => setHeight(entry.contentRect.height));
    observer.observe(element);
    return () => observer.disconnect();
  }, [fill]);

  const teeth = fill && height ? getFillTeeth(height, size) : { count, size };

  return (
    <div ref={ref} className={cn(['absolute flex flex-col', className])}>
      {new Array(teeth.count).fill(null).map((_, index) => (
        <EdgeElement key={`edge-${rest.position}-${index}`} size={teeth.size} {...rest} />
      ))}
    </div>
  );
};
